// extracted by mini-css-extract-plugin
module.exports = {"NewsFeed":"styles_NewsFeed__4rS1_","NewsFeed-title":"styles_NewsFeed-title__VEKCN","NewsFeed-items":"styles_NewsFeed-items__3OdiY"};